import React, { useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";

import DarkBlueArrow from "web/assets/images/landing-footer-darkblue.webp";
import LightBlueArrow from "web/assets/images/landing-footer-lightblue.webp";
import FooterMobileImage from "web/assets/images/landing-footer-mobile-image.webp";
import footer_logo from "../../../../assets/images/1footer_logo.svg";
import LinkedIn from "../../../../assets/images/in.svg";
import Twitter from "web/assets/images/x_twitter_new logo_icon.png";
import Facebook from "../../../../assets/images/facebook.png";

import {
  Container,
  Wrapper,
  BottomFooter,
  ReadLessStyle,
  TP,
} from "web/pages/public/landing-page/LandingFooter/LandingFooterStyled";

const currentYear = new Date().getFullYear();

const LandingFooter = ({
  showThirdDiv,
  showSecondDiv,
  showForthdDiv,
  isBackgroundWhite,
}) => {
  const [showMore, setShowMore] = useState(false);
  let history = useHistory();
  const signUp = () => {
    history.push("/registration");
  };
  const privacyPolicy = () => {
    history.push("/privacy-policy");
  };
  const websiteTerm = () => {
    history.push("/terms-of-use");
  };

  return (
    <Container>
      <Wrapper>
        <div>
          <img className="mb-4" src={footer_logo} alt="logo" />
          <ul>
            <li>
              {/* <a onClick={privacyPolicy}>PRIVACY</a> */}
              <NavLink to="/privacy-policy">PRIVACY</NavLink>
            </li>
            <li>
              {/* <a onClick={websiteTerm}>TERMS OF USE</a> */}
              <NavLink to="/terms-of-use">TERMS OF USE</NavLink>
            </li>
            <li>
              © {new Date().getFullYear()} Delancey Street Pallet Traders LLC
            </li>
            <li>
              © {new Date().getFullYear()} PalletTrader Managed Services LLC
            </li>
            <li>
              ALL RIGHTS RESERVED
            </li>
          </ul>
        </div>
        <div>
          <h4>PALLET BUYER SOLUTIONS</h4>
          <ul>
            <li>
              <NavLink to="/pallet-buyer-solutions">THE SERVICES</NavLink>
            </li>
            <li>
              <NavLink to="/self-managed-services">SELF SERVICE</NavLink>
            </li>
            <li>
              <NavLink to="/managed-services">MANAGED SERVICES</NavLink>
            </li>
            <li>
              <NavLink to="/customized-pallet-solutions">CUSTOMIZED SOLUTIONS</NavLink>
            </li>
            <li>
              <NavLink to="/pallet-supplier-and-broker-solutions#benefits">THE BENEFITS</NavLink>
            </li>
          </ul>
        </div>
        <div>
          <h4>PALLET SUPPLIER & BROKER SOLUTIONS</h4>
          <ul>
            <li>
              <NavLink to="/pallet-supplier-and-broker-solutions">FEATURES & BENEFITS</NavLink>
            </li>
            <li>
              <NavLink to="/pallet-supplier-and-broker-solutions#how">HOW IT WORKS</NavLink>
            </li>
            <li>
              <NavLink to="/founders-circle">FOUNDERS CIRCLE</NavLink>
            </li>
          </ul>
        </div>
        <div className="last-box">
          <div>
            <h4>ABOUT</h4>
            <ul>
              <li>
                <NavLink to="/about-us"> ABOUT US</NavLink>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/pallettrader/jobs/" target="_blank">CAREERS</a>
              </li>
              <li>
                <NavLink to="/about-us#faq">FAQ</NavLink>
              </li>
              <li>
                <NavLink to="/about-us#membership">MEMBERSHIP PLANS</NavLink>
              </li>
              {/* <li>
                <a>LEADERSHIP TEAM</a>
              </li>
              <li>
                <a>CAREERS</a>
              </li> */}
              <li>
                <a href="https://newsroom.pallettrader.com/" target="_blank">
                  NEWSROOM
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>CONNECT</h4>
            <ul className="icons">
              <li>
                <NavLink to="/contact-us">CONTACT US</NavLink>
              </li>
              <li>
                <NavLink to="/registration">SIGN UP</NavLink>
              </li>
              <li>
                <NavLink to="/sign-in">SIGN IN</NavLink>
              </li>
              <li><a href="tel:+1-877-777-7495">1-877-777-7495</a></li>
              <li style={{ fontSize: '13px' }}><a href="mailto:support@pallettrader.com">support@pallettrader.com</a></li>
            </ul>
            <ul className="social-icons">
              <li>
                <a
                  href="https://www.linkedin.com/company/pallettrader/"
                  target="_blank"
                >
                  <img src={LinkedIn} alt="icon" />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/Pallet_trader" target="_blank">
                  <img src={Twitter} alt="icon" />
                </a>
              </li>

              <li>
                <a
                  href="https://www.facebook.com/pallettraderdotcom/"
                  target="_blank"
                >
                  <img src={Facebook} alt="icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Wrapper>
    </Container>
  );
};

export default LandingFooter;
